import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { TNavigationBarMSRPDesktopProps } from '../types/navigationBar.types';

const NavigationBarMSRPDesktop: FC<TNavigationBarMSRPDesktopProps> = (props) => {
  const { optionalLabel1, optionalLabel2, msrp } = props;
  return (
    <div className={'navigation-bar__price-container'}>
      <Text className="navigation-bar__price-optional-label" tag="p" field={{ value: optionalLabel2 }} editable={false} />
      <span className="navigation-bar__price">
        <Text tag="p" field={{ value: optionalLabel1 }} className="navigation-bar__price-label" />
        &nbsp;
        <Text tag="p" field={{ value: msrp }} editable={false} />
      </span>
    </div>
  );
};

export default NavigationBarMSRPDesktop;
